import { Country } from 'src/app/shared/models/country';

export class State {
  public id: string;
  public name: string;
  public code: string;
  public country: Country;

  constructor(id: string, name: string, code: string, country: Country) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.country = country;
  }

  static parse(obj: any): State {
    if (!obj) return;
    let country = Country.parse(obj.country);

    return new State(obj.id, obj.name, obj.code, country);
  }
}
